module.exports = __webpack_public_path__ + "media/landing-v2/mobile_new_logo-65916474.svg";